import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TarefasService } from 'src/app/tarefas/service/tarefas.service';
import {
  ModalMensagemComponent,
  TipoModalMensagem,
} from 'src/app/shared/components/modal-mensagem/modal-mensagem.component';

@Component({
  selector: 'app-concluir-tarefa',
  standalone: true,
  imports: [CommonModule, ModalMensagemComponent],
  templateUrl: './concluir-tarefa.component.html',
  styleUrls: ['./concluir-tarefa.component.scss'],
})
export class ConcluirTarefaComponent implements OnInit {
  @Input() taskID: number | null = null;
  @Input() mostrarModalConcluir: boolean = false;
  @Output() tarefaConcluida = new EventEmitter<void>();
  @Output() fecharDialogo = new EventEmitter<boolean>();

  resultado: {
    tipo: TipoModalMensagem;
    titulo: string;
    mensagem: string;
  } | null = null;

  constructor(private _tarefaService: TarefasService) {}

  ngOnInit() {}

  fecharModal() {
    this.fecharDialogo.emit(false);
  }

  confirmarConclusao() {
    if (!this.taskID) return;
    this._tarefaService.updateStatusTask(this.taskID, 3).subscribe({
      next: () => {
        this.tarefaConcluida.emit();
        this.resultado = {
          tipo: 'sucesso',
          titulo: 'Sucesso!',
          mensagem: 'Tarefa conclu\u00edda com sucesso!',
        };
      },
      error: (err) => {
        console.error('Erro ao concluir tarefa:', err);
        this.fecharDialogo.emit(false);
      },
    });
  }

  onFecharResultado(): void {
    this.fecharDialogo.emit(true);
  }
}
